import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { ResultDto, SaldoInizialeDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class SaldoInizialeApiClient extends BaseCRUDApiClient<SaldoInizialeDto> {
  baseUrl = this.config.apiEndpoint + '/saldo-iniziale';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  canImport() {
    return this.http.get<boolean>(`${this.baseUrl}/can-import`);
  }

  canInit() {
    return this.http.get<boolean>(`${this.baseUrl}/can-init`);
  }

  checkTotals() {
    return this.http.get<boolean>(`${this.baseUrl}/check-totals`);
  }

  importExcelFile(file: File) {
    this._pagedCache.clear();
    const fd = new FormData();
    fd.append('file', file);
    return this.http.post<ResultDto>(this.baseUrl + '/import', fd);
  }

  initSaldoIniziale() {
    this._pagedCache.clear();
    return this.http.post<void>(`${this.baseUrl}/init`, {});
  }

  deleteAll() {
    this._pagedCache.clear();
    return this.http.delete(`${this.baseUrl}/delete-all`);
  }
}
